import { useState } from "react";
import { icons } from "./icons";

// ─────────────────────────────────────────────────────────────
// Logo images stay exactly as-is — brand logos (MTN, DSTV, etc.)
// aren't themed, they're fixed assets. Only the fallback Remix-Icon
// chip (used when no logo image is available, or it fails to load)
// switches its background tint between light/dark via CSS vars.
// ─────────────────────────────────────────────────────────────

export function getTxIcon(tx) {
  const type     = (tx.type     || "").toLowerCase();
  const asset    = (tx.asset    || "").toUpperCase();
  const name     = (tx.assetName|| "").toLowerCase();
  const network  = (tx.metadata?.network  || "").toUpperCase();
  const disco    = (tx.metadata?.disco    || "").toUpperCase();
  const provider = (tx.metadata?.provider || "").toUpperCase();

  if (type === "bill_payment") {
    if (network === "MTN"     || name.includes("mtn"))     return { img: icons.mtn,    tone: "warning" };
    if (network === "AIRTEL"  || name.includes("airtel"))  return { img: icons.airtel, tone: "danger" };
    if (network === "GLO"     || name.includes("glo"))     return { img: icons.glo,    tone: "success" };
    if (network === "9MOBILE" || name.includes("9mobile")) return { img: null, ri: "ri-phone-line",      tone: "success" };

    if (provider === "DSTV"      || name.includes("dstv"))     return { img: icons.dstv,   tone: "info" };
    if (provider === "GOTV"      || name.includes("gotv"))     return { img: icons.gotv,   tone: "danger" };
    if (provider === "STARTIMES" || name.includes("startimes"))return { img: null, ri: "ri-tv-2-line",   tone: "warning" };

    if (disco === "EKEDC"  || name.includes("eko"))    return { img: icons.ekedc,  tone: "warning" };
    if (disco === "IKEDC"  || name.includes("ikeja"))  return { img: icons.ikedc,  tone: "danger" };
    if (disco === "AEDC"   || name.includes("abuja"))  return { img: icons.aedc,   tone: "success" };
    if (disco === "BEDC"   || name.includes("benin"))  return { img: icons.bedc,   tone: "purple" };
    if (disco === "IBEDC"  || name.includes("ibadan")) return { img: icons.ibedc,  tone: "purple" };
    if (disco === "JEDC"   || name.includes("jos"))    return { img: icons.jedc,   tone: "info" };
    if (disco === "KAEDCO" || name.includes("kaduna")) return { img: icons.kaedco, tone: "warning" };
    if (disco === "PHEDC"  || name.includes("port"))   return { img: icons.phed,   tone: "info" };

    if (asset === "DATA")        return { img: null, ri: "ri-wifi-line",       tone: "info" };
    if (asset === "ELECTRICITY") return { img: null, ri: "ri-flashlight-line", tone: "warning" };
    if (asset === "TV")          return { img: null, ri: "ri-tv-2-line",       tone: "purple" };
    return                              { img: null, ri: "ri-receipt-line",    tone: "muted" };
  }

  if (type === "buy")                                        return { img: null, ri: "ri-arrow-down-line",        tone: "success" };
  if (type === "sell")                                       return { img: null, ri: "ri-arrow-up-line",          tone: "danger" };
  if (type === "deposit")                                    return { img: null, ri: "ri-arrow-down-circle-line", tone: "success" };
  if (type === "withdrawal" || type === "withdraw_crypto")   return { img: null, ri: "ri-arrow-up-circle-line",   tone: "warning" };
  if (type === "withdraw_naira")                             return { img: null, ri: "ri-bank-line",              tone: "warning" };

  return { img: null, ri: "ri-exchange-line", tone: "muted" };
}

const TONE_VARS = {
  success: { color: "var(--color-success)", bg: "var(--color-success-light)", border: "var(--color-success-border)" },
  warning: { color: "var(--color-warning)", bg: "var(--color-warning-light)", border: "var(--color-warning-border)" },
  danger:  { color: "var(--color-danger)",  bg: "var(--color-danger-light)",  border: "var(--color-danger-border)" },
  info:    { color: "var(--color-info)",    bg: "var(--color-info-light)",    border: "var(--color-info-border)" },
  purple:  { color: "var(--color-purple)",  bg: "var(--color-purple-light)",  border: "var(--color-purple-border)" },
  muted:   { color: "var(--color-text-muted)", bg: "var(--color-surface-hover)", border: "var(--color-border)" },
};

export function TxIconCell({ tx, size = "w-10 h-10", rounded = "rounded-xl" }) {
  const { img, ri, tone } = getTxIcon(tx);
  const [imgFailed, setImgFailed] = useState(false);
  const v = TONE_VARS[tone] || TONE_VARS.muted;

  if (img && !imgFailed) {
    return (
      <div
        className={`${size} ${rounded} flex items-center justify-center overflow-hidden flex-shrink-0`}
        style={{ background: v.bg, border: `1px solid ${v.border}` }}
      >
        <img
          src={img} alt=""
          className="w-[65%] h-[65%] object-contain"
          onError={() => setImgFailed(true)}
        />
      </div>
    );
  }

  return (
    <div
      className={`${size} ${rounded} flex items-center justify-center flex-shrink-0`}
      style={{ background: v.bg }}
    >
      <i className={`${ri} text-lg`} style={{ color: v.color }} />
    </div>
  );
}